module.exports = __webpack_public_path__ + "img/Diagnosis - Dark Gray - Selected.c6eaab81.png";